module.exports = __webpack_public_path__ + "static/media/social-media-svgrepo-com.af5c9bac.svg";